import { render, staticRenderFns } from "./ErrorFeedback.vue?vue&type=template&id=62239a38&"
import script from "./ErrorFeedback.vue?vue&type=script&lang=js&"
export * from "./ErrorFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports